import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    fontSize: '0.625rem',
    display: 'block',
    marginTop: '0.5rem',
  },
  info: {
    color: theme.palette.secondary['1000'],
  },
  warning: {
    color: theme.palette.accent2['1000'],
  },
  success: {
    color: theme.palette.primary['1000'],
  },
  danger: {
    color: theme.palette.accent3['1000'],
  },
});


const FormSpan = ({ color, classes, children }) => (
  <span className={`${classes.root} ${classes[color]}`}>
    {children}
  </span>
);

FormSpan.propTypes = {
  color: PropTypes.string,
  children: PropTypes.string.isRequired,
  classes: PropTypes.string.isRequired,
};

FormSpan.defaultProps = {
  color: 'info',
};


export default withStyles(styles)(FormSpan);
